<template>
  <section :class="['py-16', { 'bg-gray-50': background === 'gray' }]">
    <div class="container mx-auto px-4 max-w-7xl">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  background?: 'white' | 'gray'
}

withDefaults(defineProps<Props>(), {
  background: 'white'
})
</script>